import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

// Material UI
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';

// Components
import Modal from '../index';
import useStyles from './styles';

const ModalSuccess = ({ open, success, error, errorText, successText, processText, onSuccess, onError, intervale, ...rest }) => {
    const { classes } = useStyles();

    useEffect(() => {
        const handleSuccess = success && onSuccess
            ? setTimeout(() => onSuccess(), intervale)
            : null

        return () => {
            if (handleSuccess)
                clearTimeout(handleSuccess)
        };
    }, [success, intervale, onSuccess])

    useEffect(() => {
        const handleSuccess = error && onError
            ? setTimeout(() => onError(), intervale)
            : null

        return () => {
            if (handleSuccess)
                clearTimeout(handleSuccess)
        };
    }, [error, intervale, onError])

    const SuccessComponent = () => (
        <div className={`${classes.container} ${classes.success}`}>
            <Typography variant='h6' component='h3'>
                {successText}
            </Typography>
            <div className={classes.icon}>
                <CheckCircleIcon />
            </div>
        </div>
    )

    const ProcessComponent = () => (
        <div className={classes.container}>
            <Typography variant='h6' component='h3'>
                {processText}
            </Typography>
            <CircularProgress />
        </div>
    )

    const ErrorComponent = () => (
        <div className={`${classes.container} ${classes.error}`}>
            <Typography variant='h6' component='h3'>
                {errorText}
            </Typography>
            <div className={classes.icon}>
                <ErrorIcon />
            </div>
        </div>
    )

    return (
        <Modal
{...rest} open={open}
            classes={{ paperWidthSm: classes.paperWidthSm }}
            contentProps={{ classes: { root: classes.content } }}
        >
            {
                success && !error && 
                    <SuccessComponent />
            }
            {
                !success && !error && 
                    <ProcessComponent />
            }
            {
                !success && error && 
                    <ErrorComponent />
            }
        </Modal>
    )
}

ModalSuccess.defaultProps = {
    open: false,
    success: false,
    error: false,
    successText: 'Exito al procesar',
    processText: 'Procesando',
    errorText: 'Ocurrio un error',
    intervale: 3000
}

ModalSuccess.propTypes = {
    open: PropTypes.bool,
    success: PropTypes.bool,
    successText: PropTypes.string,
    processText: PropTypes.string,
    onSuccess: PropTypes.func,
    intervale: PropTypes.number
}

export default ModalSuccess;